webpackJsonp([104],{

/***/ "zqBo":
/***/ (function(module, exports) {

var Background = (function () {
    function Background() {
        if (this.imageUrl) {
            this.style = {
                'background-image': "url(" + this.imageUrl + ")"
            };
        }
    }
    return Background;
}());
angular.module('animatronApp.background', []).component('background', {
    bindings: {
        bgStyle: '@',
        imageUrl: '<'
    },
    transclude: true,
    controller: Background,
    template: "<div \n                class=\"background {{ $ctrl.bgStyle }}\" \n                ng-style=\"$ctrl.style\" \n                ng-transclude\n              ></div>"
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/104-28dc41a6a889e793a2e2.min.js